import { useNavigate } from "react-router-dom";
import { Alert, Button, Modal } from "react-bootstrap";

export interface DeferredRequestNotStartedViewProps {
  cancelPolling: () => void;
}

const DeferredRequestNotStartedView = ({
  cancelPolling,
}: DeferredRequestNotStartedViewProps) => {
  const navigate = useNavigate();

  const ok = () => {
    cancelPolling();
    navigate("/");
  };

  return (
    <>
      <Modal.Body>
        <Alert variant="info">Your data is queued for processing</Alert>
        <div>
          You don't have to wait...
          <br />
          We will email you once the order is ready or go to 'My Orders' to download.
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={ok}>
          Ok
        </Button>
      </Modal.Footer>
    </>
  );
};

export default DeferredRequestNotStartedView;
